import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { CrmPipelineStats } from "@shared/modules/crm";
import { api } from "../../../core/lib/api";
import { Card } from "../../../core/components/ui/card";
import { formatCents } from "../lib/crm";

/** Trois chiffres clés du pipeline sur l'accueil, avec un raccourci vers le CRM. */
export function CrmHomeWidget() {
  const [stats, setStats] = useState<CrmPipelineStats | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    api<CrmPipelineStats>("/api/crm/stats")
      .then((s) => {
        setStats(s);
        setFailed(false);
      })
      .catch(() => setFailed(true));
  }, []);

  return (
    <Card title="CRM" subtitle="Où en est le pipeline aujourd'hui." actions={<Link to="/crm">Ouvrir</Link>}>
      {failed ? (
        <p className="crm-home__empty">Chiffres indisponibles pour l'instant.</p>
      ) : (
        <dl className="crm-home">
          <div className="crm-home__stat">
            <dt className="crm-home__label">Dossiers actifs</dt>
            <dd className="crm-home__value">{stats ? stats.activeAccountCount : "—"}</dd>
          </div>
          <div className="crm-home__stat">
            <dt className="crm-home__label">MRR contractuel</dt>
            <dd className="crm-home__value">{stats ? formatCents(stats.activeMrrCents) : "—"}</dd>
          </div>
          <div className="crm-home__stat">
            <dt className="crm-home__label">Suivis en retard</dt>
            <dd className={`crm-home__value${stats && stats.overdueTaskCount > 0 ? " crm-home__value--alert" : ""}`}>
              {stats ? stats.overdueTaskCount : "—"}
            </dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
